/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { withConsumer } from '../../../../contexts';
import { ModalsConsumer } from '../../../../contexts/ModalsContext';
import DotComponent from '../../../ui/DotComponent';

import * as styles from './index.styles';
import { Icon } from '../../../ui/Icon';
import { get } from 'lodash';

class Header extends SafePureComponent {
  safeRender() {
    const { activeStep, fields } = this.props;
    const HeaderTitle = get(fields, 'FormTitle.value', '');
    const PhoneNumber = get(fields, 'PhoneNumber.value', '');
    const ShowCloseButton = get(fields, 'ShowCloseButton.value', false);
    const CloseButtonText = get(fields, 'CloseButtonText.value', false);

    return (
      <div css={[styles.book_visit_head]}>
        <div className="header_left">
          {activeStep < 3 && (
            <h2>
              {HeaderTitle}
              <DotComponent />
            </h2>
          )}
        </div>
        <div className="header_right">
          {PhoneNumber && (
            <div className="call_section">
              <a href={`tel:${PhoneNumber}`}>
                <span className="call_no_txt">
                  <span className="icon_tel">
                    <Icon name="contact" className="phone-default-icon" />
                  </span>
                  <span className="callustxt">Call us</span>
                </span>
                <span className="call_no">{PhoneNumber}</span>
              </a>
            </div>
          )}
          {ShowCloseButton && (
            <div className="close-btn">
              <button
                onClick={this.props.onRequestClose}
                aria-label={CloseButtonText}
                css={[styles.closeButtonCss]}
              >
                <span>
                  <i css={styles.iconCss} className="icon-closer" />
                </span>
                <span>{CloseButtonText}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Header.displayName = 'BookVisit/Header';

export default compose(
  withNamespaces(),
  withConsumer(ModalsConsumer, 'modalsContext'),
)(Header);
